/**
 * Created by lency on 9/19/16.
 */

class AppController {

    constructor(AppConfig, pageTitle, userLogin, $timeout, $http,$rootScope,$transitions,Jurisdiction) {
        "ngInject";

        let self = this;
        this.$timeout=$timeout;
        this.$rootScope=$rootScope
        this.userLogin=userLogin;
        pageTitle.init();
        this.$transitions = $transitions;
        this.Jurisdiction = Jurisdiction
        // this.permission = JSON.parse(window.localStorage.getItem("loginUser"))
        //禁止双指缩放
        $('html,body').on('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        });
        //手机页面只在当前页面打开
        if(window.innerWidth<767){
            $('body').on('click','a',function () {
                $(this).attr('target','_self')
            })
        }

        function getTiming () {
            const time = performance.timing;

            if(time.loadEventEnd === 0) {
                setTimeout(getTiming, 200);
                return;
            }
            const loadTime = time.loadEventEnd - time.navigationStart;
            if (loadTime >  AppConfig.report_threshold_value) {
                report(loadTime)
            }

        }

        function report (loadTime) {
            $http.post(AppConfig.server_url + '/home/load/report', {load: loadTime})
              .then(res => {
                  if (res.data.status.code !== 200) {
                      report(loadTime)
                  }
              }, err => {
                  report(loadTime)
              })
        }

        getTiming()
        // this.checkRoute()

    }

    

    loadQiYuCustomerService(user) {
        this.$rootScope.user=user
        let src = "https://qiyukf.com/script/d00a137e9451aefaa146c20b637c4047.js";

        if(user.id)
        {
            src = src + '?uid=' + user.id + '&name=' + user.pseudonym + '&email=' + user.email;
        }

        let qy = document.createElement("script");
        qy.src = src;
        qy.defer = 1;
        qy.async = 1;
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(qy, s);
    }
    $onInit() {
        this.$timeout(() => {
            this.userLogin.loadUser((user) => {
                this.loadQiYuCustomerService(user);
            })
        })
    }

    checkRoute(){


        this.$transitions.onStart({to:"app.home.**"}, (trans) => {
            
            // this.permission = JSON.parse(window.localStorage.getItem("loginUser"))
            // //   console.log(this.permission.role_type)
            // var statess = trans.router.stateService;

            // let route = trans._treeChanges.to[trans._treeChanges.to.length-1].state.name;
            
            // let params = Object.assign(this.permission,{route_name:route,checkType:"redirect_route"})
            // let Identity = this.Jurisdiction.checkStatus(params)


            // if(Identity === "admin"){
            //     return 
            // }else if(!Identity.status){

            //    return statess.target(Identity.path);
            // }else{
            //     return 
            // }

            
            this.permission = JSON.parse(window.localStorage.getItem("loginUser"))
            
            let params = Object.assign(this.permission,{checkType:"redirect_route"})

            return this.Jurisdiction.reselut(params,trans)

        });


    }


}

export default AppController;



// WEBPACK FOOTER //
// ./src/app/app.controller.js